import Consts from "Interfaces/Consts";

interface Props {
    componentId: string;
    show: boolean;
    classForMsg: () => string;
    closeMsg: () => void;
}

const ContactUsSuccess: React.FC<Props> = ({ componentId, show, classForMsg, closeMsg }) => {

    return <div id={`contact-success-${componentId}`}
        className={`mst-success-msg mx-auto text-center
            ${show ? 'd-block' : 'd-none'}
            ${classForMsg()}`
        }>

        <div className="center-line">

            <img id={`SendSuccess-${componentId}`} src="/Images/Components/SendSuccess.svg" alt="" />

            <div className="mst-msg-txt pt-3 mx-auto"> {Consts.sendSuccessMsg}</div>

            <div className="mst-msg-btn pt-5">
                <button className="" type="button" onClick={closeMsg}>
                    {Consts.close}
                </button>
            </div>

        </div>

    </div>
}

export default ContactUsSuccess;